module.exports = __webpack_public_path__ + "static/media/about-the-stick@2x.2b0b94e4.png";